<template>
  <div class="alert-status-bg">
    <img
      class="alert-status-bg__img"
      :src="imgComponent"
      alt="Preview of the icon representing the alert"
    />
    <h4 class="alert-status-bg__error">
      {{ error }}
    </h4>
    <p class="alert-status-bg__instruction">
      {{ instruction }}
    </p>
  </div>
</template>

<script>
import FailLowImg from '@/assets/images/status/fail-low.png'
import FailMediumImg from '@/assets/images/status/fail-medium.png'
import FailHighImg from '@/assets/images/status/fail-high.png'
import SuccessImg from '@/assets/images/status/success.png'

const imgMap = {
  FAIL_LOW: FailLowImg,
  FAIL_MEDIUM: FailMediumImg,
  FAIL_HIGH: FailHighImg,
  SUCCESS: SuccessImg,
}

export default {
  name: 'AlertStateBg',
  props: {
    alert: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: true,
    },
    instruction: {
      type: String,
      required: true,
    },
  },
  computed: {
    imgComponent() {
      return imgMap[this.alert]
    },
  },
}
</script>

<style scoepd lang="scss">
.alert-status-bg {
  display: flex;
  align-items: center;
  flex-flow: column;

  &__img {
    width: 280px;
  }
  &__error {
    margin: -50px 0 20px 0;
    color: var(--white);
    font-family: var(--font-bold);
    font-style: normal;
    font-weight: 700;
    font-size: rem(20px);
    line-height: rem(26px);
  }
  &__instruction {
    color: var(--light-blue-gray);
    font-family: var(--font-book);
    font-style: normal;
    font-weight: 450;
    font-size: rem(16px);
    line-height: rem(24px);
  }
}
</style>
